"use client"
import { Dialog } from "@headlessui/react";
import React, { useState } from "react";
import * as FaB from "react-icons/fa6";

interface Props {
    show: boolean;
    title: string;
    text: string;
    close: () => void;
    type: string;
    showbtn: boolean;
}

function ModalComp({ show, title, text, close, type, showbtn }: Props) {

    const check = <FaB.FaCircleCheck size={60} fill={"#33a683"}/>;
    const info = <FaB.FaCircleInfo size={60} fill={"#1286ed"}/>;
    const err = <FaB.FaCircleExclamation size={60} fill={"#db5166"}/>;
    const gen = <FaB.FaEllipsis size={60} fill={""}/>;


    function iconShow() {
        if (type == "SUCCESS") {
            return check
        } else if (type == "INFO") {
            return info
        } else if (type == "ERROR") {
            return err
        } else {
            return gen
        }
    }


    return (
        <div className="">
            <Dialog as="div" open={show} onClose={close}>

                <div className="fixed inset-0 overflow-y-auto z-50">
                    <div className="flex min-h-full items-center justify-center p-2 text-center">
                        <Dialog.Panel className="w-3/4 md:w-1/2 lg:w-1/4 h-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <div className="h-full">
                                <Dialog.Title className="p-2 flex-row w-full rounded-md text-center leading-6 text-2xl text-gray-900 ">
                                <div className="p-2 flex justify-center">
                                    {iconShow()}
                                </div>
                                <div className="p-2">
                                    {title}
                                </div>
                                </Dialog.Title>

                                <Dialog.Description className="p-2 h-full text-xl text-center font-normal leading-6 text-gray-900 mb-3">
                                    {text}
                                </Dialog.Description>
                            </div>
                            {showbtn?<div className="">
                                <button
                                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-500 px-4 py-2 w-full text-sm font-medium text-white hover:bg-blue-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                    onClick={close}>Close</button>
                            </div>:""}
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default ModalComp;